import React from 'react';
import { ListStore } from 'shared/stores/ListStore';
import { observer } from 'mobx-react';
import ApplicantChangelogTable from './ApplicantChangelogTable';
import { applicantChangelogStore } from './ApplicantChangelogStore';
import { Pagination } from 'ats/components/pagination/Pagination';
import Dropdown from 'ats/components/dropdown/Dropdown';
import ChangelogEmptyState from 'ats/components/empty-state/ChangelogEmptyState';

@observer
export class ApplicantChangelog extends React.Component {
	constructor(props) {
		super(props);
		this.listStore = new ListStore(applicantChangelogStore, {
			entityName: 'Applicant Changelog'
		});
		this.listStore.beginLoading();
	}

	loadApplicantChangelog = applicant => {
		if (!applicant?.id) return;

		applicantChangelogStore.setQuery('applicantId', applicant.id);
		applicantChangelogStore.setQuery('sort', {
			column: 'createdAt',
			asc: false
		});
		this.listStore.search();
	};

	componentDidMount() {
		this.loadApplicantChangelog(this.props.applicant);
	}

	componentDidUpdate(prevProps) {
		const { applicant } = this.props;
		if (prevProps.applicant?.id !== applicant?.id && applicant?.id) {
			this.loadApplicantChangelog(applicant);
		}
	}

	handlePaginationChange = value => {
		this.listStore.handlePaginationChange(
			value,
			this.listStore.store.query.pagination.limit
		);
	};

	render() {
		const typeFilterDropdown = (
			<Dropdown
				value={this.listStore.store.query.columnName}
				name="columnName"
				onChange={newValue => {
					this.listStore.store.setQuery('columnName', newValue);
					this.handlePaginationChange(1);
				}}
				optionValue="value"
				options={[
					{ label: 'All', value: null },
					...applicantChangelogStore.typeOptions
				]}
				placeholder="All"
				displayValue={value => `Type: ${value}`}
			/>
		);

		const showEmptyState =
			!this.listStore.loading && this.listStore.data.length === 0;
		const hasEntries = this.listStore.data.length > 0;

		return (
			<div className="applicant-changelog-tab">
				<div className="applicant-tab-section-header applicant-changelog-section-header">
					<div className="applicant-tab-section-title">Log</div>
					<div className="table-action-buttons applicant-changelog-header-tools">
						<Pagination
							loading={this.listStore.loading}
							pagination={this.listStore.store.query.pagination}
							onPaginationChange={this.handlePaginationChange}
							hidePageControls
							customButton={typeFilterDropdown}
						/>
					</div>
				</div>
				<div className="applicant-changelog">
					<ApplicantChangelogTable
						data={this.listStore.data}
						sort={this.listStore.store.query.sort}
						onSort={this.listStore.handleSort}
						isEmpty={showEmptyState}
						loading={this.listStore.loading}
						emptyState={<ChangelogEmptyState />}
					/>
					{hasEntries ? (
						<Pagination
							loading={this.listStore.loading}
							pagination={this.listStore.store.query.pagination}
							onPaginationChange={this.handlePaginationChange}
							hideLimitSelect
						/>
					) : null}
				</div>
			</div>
		);
	}
}
